import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import Select from '../Select/Select'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { useAppSelector } from '../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

// TODO--låg-prio slå ihop komponent med SizePanel!
const ASSEMBLY_ID = 'assembly'

const OptionsPanel: React.FC = () => {
  const configurator = useConfiguratorContext()

  const { props } = useAppSelector((state) => state.configResult) || {}
  const { gutters, foundation, sillColor, garageDoorMotors } = props || {}
  const { content } = useAppSelector((state) => state.init) || {}

  return (
    <Styled.Panel>
      <Select
        id="gutters"
        value={gutters.value}
        onChange={(event) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            gutters: event.target.value as any,
          })
        }}
        options={gutters.options.flatMap((option: any) =>
          option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
        )}
        formatterForOption={(value) => content?.props?.gutters?.options?.[value]?.title}
        label={content?.props?.gutters?.title}
        dangerouslySetInfo={content?.props?.gutters?.informationText}
      />
      <Select
        id="klara-foundation"
        value={foundation.value}
        onChange={(event) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            foundation: event.target.value as any,
          })
        }}
        options={foundation.options.flatMap((option: any) =>
          option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
        )}
        formatterForOption={(value) => content?.props?.foundation?.options?.[value]?.title}
        label={content?.props?.foundation?.title}
        dangerouslySetInfo={content?.props?.foundation?.informationText}
      />
      <Select
        id="facade-sheet-metal-color"
        value={sillColor.value}
        onChange={(event) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            sillColor: event.target.value as any,
          })
        }}
        options={[
          { key: 'white', value: 'white', disabled: false },
          { key: 'black', value: 'black', disabled: false },
        ]}
        formatterForOption={(value) => content?.props?.facadeSheetMetalColor?.options?.[value]?.title}
        label={content?.props?.facadeSheetMetalColor?.title}
        dangerouslySetInfo={content?.props?.facadeSheetMetalColor?.informationText}
      />
      <Select
        id="garage-motors"
        value={garageDoorMotors.value}
        // disabled={garageDoorMotors.options.filter((x: any) => !x.disabled).length <= 1} // TODO
        onChange={(event) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            garageDoorMotors: event.target.value as any,
          })
        }}
        options={garageDoorMotors.options.flatMap((option: any) =>
          option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
        )}
        formatterForOption={(value) =>
          value === 0 ? content?.props?.garageMotors?.none : `${value} ${content?.props?.garageMotors?.unit}`
        }
        label={content?.props?.garageMotors?.title}
        dangerouslySetInfo={content?.props?.garageMotors?.informationText}
      />
    </Styled.Panel>
  )
}

export default OptionsPanel
